import Vue from 'vue'
import Router from 'vue-router'
/* criminalLayout */
import criminalLayout from '@/views/criminal/Layout'
import lawLayout from '@/views/law/Layout'
import forecastLayout from '@/views/forecast/Layout'
import caseLayout from '@/views/cases/Layout'
import localLayout from '@/views/Layout'
import otherSysLayout from '@/views/otherSysLayout/Layout'

Vue.use(Router)
//解决vue路由重复导航错误
//获取原型对象上的push函数
const originalPush = Router.prototype.push
//修改原型对象中的push方法
Router.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}

export const constantRoutes = [{
    path: '/criminal/home',
    component: criminalLayout,
    children: [{
      path: 'criminalHome',
      component: () =>
        import ('@/views/criminal/home'),
      name: 'criminalHome',
      meta: { title: 'criminalHome', noCache: true, affix: false }
    }]
  },
  {
    path: '/',
    component: lawLayout,
    redirect: ''
  },
  {
    path: '/law',
    component: lawLayout,
    children: [{
      path: '/law/home',
      component: () =>
        import ('@/views/law/home'),
      name: 'lawHome',
      meta: { title: 'lawHome', noCache: true, affix: false, documentTitle: '小包公智能法规检索', isThird: true }
    }]
  },
  {
    path: '/forecast',
    component: forecastLayout,
    children: [{
      path: '/forecast/home',
      component: () =>
        import ('@/views/forecast/highHome'),
      name: 'forecastHome',
      meta: { title: 'forecastHome', noCache: true, documentTitle: '小包公智能量刑辅助系统', isThird: true }
    },{
      path: '/forecast/report-list',
      component: () => import('@/views/forecast/reportList'),
      name: 'forecastReportList',
      meta: { title: 'forecastReportList', noCache: true, documentTitle: '小包公智能量刑辅助系统', isThird: true }
    },
    {
      path: '/forecast/center',
      component: () =>
        import ('@/views/center/index'),
      name: 'forecastCenter',
      meta: { title: 'forecastCenter', noCache: true, isThird: true }
    }]
  },
  {
    path: '/law',
    component: lawLayout,
    children: [{
      path: '/law/detail',
      component: () =>
        import ('@/views/law/lawDetail'),
      name: 'lawDetail',
      meta: { title: 'lawDetail', noCache: true, documentTitle: '小包公智能法规检索', isThird: true }
    },{
      path: '/law/relation',
      component: () =>
        import ('@/views/law/lawRelation'),
      name: 'lawRelation',
      meta: { title: 'lawRelation', noCache: true, documentTitle: '小包公智能法规检索', isThird: true }
    },{
      path: '/law/center',
      component: () =>
        import ('@/views/center/index'),
      name: 'lawCenter',
      meta: { title: 'lawCenter', noCache: true, documentTitle: '小包公智能法规检索' }
    }]
  },
  {
    path: '/law',
    component: lawLayout,
    children: [{
      path: '/law/full/text',
      component: () =>
        import ('@/views/law/fullText'),
      name: 'fullText',
      meta: { title: 'fullText', noCache: true, documentTitle: '小包公智能法规检索', isThird: true }
    }]
  },
  {
    path: '/law',
    component: lawLayout,
    children: [{
      path: '/law/clause',
      component: () =>
        import ('@/views/law/lawClause'),
      name: 'lawClause',
      meta: { title: 'lawClause', noCache: true, documentTitle: '小包公智能法规检索', isThird: true }
    }, {
      path: '/law/midpage',
      component: () =>
        import ('@/views/law/midpage'),
      name: 'midPage',
      meta: { title: 'midPage', noCache: true, documentTitle: '小包公智能法规检索', isThird: true }
    }, {
      path: '/law/relante',
      component: () =>
        import ('@/views/law/relantList'),
      name: 'relantList',
      meta: { title: 'relantList', noCache: true, documentTitle: '小包公智能法规检索', isThird: true }
    }]
  },
  {
    path: '/law',
    component: lawLayout,
    children: [{
      path: '/law/local/list',
      component: () =>
        import ('@/views/law/localList'),
      name: 'localList',
      meta: { title: 'localList', noCache: true, documentTitle: '小包公智能法规检索', isThird: true }
    }]
  },
  {
    path: '/law',
    component: lawLayout,
    children: [{
      path: '/law/case/list',
      component: () =>
        import ('@/views/law/caseList'),
      name: 'caseList',
      meta: { title: 'caseList', noCache: true, documentTitle: '小包公智能法规检索', isThird: true }
    }]
  },
  {
    path: '/law',
    component: lawLayout,
    children: [{
      path: '/law/explain/list',
      component: () =>
        import ('@/views/law/explainList'),
      name: 'explainList',
      meta: { title: 'explainList', noCache: true, documentTitle: '小包公智能法规检索', isThird: true }
    }]
  },
  {
    path: '/law',
    component: lawLayout,
    children: [{
      path: '/law/case/detail',
      component: () =>
        import ('@/views/law/caseDetail'),
      name: 'caseDetail',
      meta: { title: 'caseDetail', noCache: true, documentTitle: '小包公智能法规检索', isThird: true }
    }]
  },
  {
    path: '/forecast',
    component: forecastLayout,
    children: [{
      path: '/forecast/step',
      component: () =>
        import ('@/views/forecast/step'),
      name: 'forecastStep',
      meta: { title: 'forecastStep', noCache: true, documentTitle: '小包公智能量刑辅助系统', isThird: true }
    }]
  },
  {

    path: '/forecast',
    component: forecastLayout,
    children: [{
      path: '/forecast/uploadStep',
      component: () =>
        import ('@/views/forecast/uploadStep'),
      name: 'forecastUploadStep',
      meta: { title: 'forecastUploadStep', noCache: true, documentTitle: '小包公智能量刑辅助系统', isThird: true }
    }]
  },
  {
    path: '/forecast',
    component: forecastLayout,
    children: [{
      path: '/forecast/dashboard',
      component: () =>
        import ('@/views/forecast/dashboard'),
      name: 'forecastDashboard',
      meta: { title: 'forecastDashboard', noCache: true, documentTitle: '小包公智能量刑辅助系统', isThird: true }
    }]
  },
  {
    path: '/forecast',
    component: forecastLayout,
    children: [{
      path: '/forecast/report',
      component: () =>
        import ('@/views/forecast/report'),
      name: 'forecastReport',
      meta: { title: 'forecastReport', noCache: true, documentTitle: '小包公智能量刑辅助系统', isThird: true }
    }]
  },
  {
    path: '/forecast',
    component: forecastLayout,
    children: [{
      path: '/forecast/multi/report',
      component: () =>
        import ('@/views/forecast/multiReport'),
      name: 'forecastMultiReport',
      meta: { title: 'forecastMultiReport', noCache: true, documentTitle: '小包公智能量刑辅助系统', isThird: true }
    }]
  },
  {
    path: '/forecast',
    component: forecastLayout,
    children: [{
      path: '/forecast/innocent',
      component: () =>
        import ('@/views/forecast/innocent'),
      name: 'forecastInnocent',
      meta: { title: 'forecastInnocent', noCache: true, documentTitle: '小包公智能量刑辅助系统', isThird: true }
    }]
  },
  {
    path: '/forecast',
    component: forecastLayout,
    children: [{
      path: '/forecast/case/detail',
      component: () =>
        import ('@/views/forecast/caseDetail'),
      name: 'forecastCaseDetail',
      meta: { title: 'forecastCaseDetail', noCache: true, documentTitle: '小包公智能量刑辅助系统', isThird: true }
    }]
  },
  {
    path: '/forecast',
    component: forecastLayout,
    children: [{
      path: '/forecast/center',
      component: () =>
        import ('@/views/forecast/center'),
      name: 'forecastCenter',
      meta: { title: 'forecastCenter', noCache: true, documentTitle: '小包公智能量刑辅助系统', isThird: true }
    }]
  },
  {
    path: '/case',
    component: caseLayout,
    children: [{
      path: '/case/result',
      component: () =>
        import ('@/views/cases/result'),
      name: 'caseResult',
      meta: { title: 'caseResult', noCache: true, documentTitle: '小包公智能类案检索', isThird: true }
    }]
  },
  {
    path: '/case',
    component: caseLayout,
    children: [{
      path: '/case/result/detail',
      component: () =>
        import ('@/views/cases/caseResDetail'),
      name: 'caseResDetail',
      meta: { title: 'caseResDetail', noCache: true, documentTitle: '小包公智能类案检索', isThird: true }
    }, {
      path: '/case/report',
      component: () =>
        import ('@/views/cases/caseReport'),
      name: 'caseReport',
      meta: { title: 'caseReport', noCache: true, documentTitle: '小包公智能类案检索', isThird: true }
    }]
  },
  {
    path: '/main',
    component: localLayout,
    children: [{
      path: '/main/home',
      component: () =>
        import ('@/views/home'),
      name: 'mainHome',
      meta: { title: 'mainHome', noCache: true, isThird: location.origin.indexOf('http://localhost:') === 0 }
    }]
  },
  {
    path: '/main',
    component: localLayout,
    children: [{
      path: '/main/search',
      component: () =>
        import ('@/views/search'),
      name: 'mainSearch',
      meta: { title: 'mainSearch', noCache: true, documentTitle: '小包公智能法规检索', isThird: true }
    }]
  },
  {
    path: '/case',
    component: caseLayout,
    children: [{
      path: '/case/search',
      component: () =>
        import ('@/views/cases/search'),
      name: 'caseSearch',
      meta: { title: 'caseSearch', noCache: true, documentTitle: '小包公智能类案检索', isThird: true }
    },{
      path: '/case/collect',
      component: () =>
        import ('@/views/cases/collect'),
      name: 'caseCollect',
      meta: { title: 'caseCollect', noCache: true, documentTitle: '小包公智能类案检索', isThird: true }
    },{
      path: '/case/center',
      component: () =>
        import ('@/views/center/index'),
      name: 'caseCenter',
      meta: { title: 'caseCenter', noCache: true, documentTitle: '小包公智能类案检索' }
    }]
  },
  {
    path: '/main',
    component: localLayout,
    children: [{
      path: '/main/center',
      component: () =>
        import ('@/views/center/index'),
      name: 'mainCenter',
      meta: { title: 'mainCenter', noCache: true }
    }]
  },
  {
    path: '/wechat/login',
    component: () =>
      import ('@/views/wechat'),
    name: 'mainWechat'
  },
  {
    path: '/main',
    component: localLayout,
    children: [{
      path: '/main/analysis',
      component: () =>
        import ('@/views/analysis'),
      name: 'mainAnalysis',
      meta: { title: 'mainAnalysis', noCache: true }
    }]
  },{
    path: '/help',
    component: ()=>
       import ('@/views/help'),
    name: 'help'   
  },{
    path: '/help/detail',
    component: ()=>
       import ('@/views/help/detail'),
    name: 'help'   
  },
  {
    path: '/sys-layout',
    component: otherSysLayout,
    children: [{
      path: '/case-handlin/center',
      component: () =>
        import ('@/views/center/index'),
      name: 'caseHandlinCenter',
      meta: { title: 'caseHandlinCenter', noCache: true }
    }]
  },
  {
    path: '/*',
    redirect: () => {
      window.location.href = window.location.origin + '/notFound.html';
    }
  }
]
export default new Router({
  routes: constantRoutes
})


// WEBPACK FOOTER //
// ./src/router/index.js